
import { StatusBar } from 'expo-status-bar';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
    Text,
    View,
    StyleSheet,
    KeyboardAvoidingView,
    Platform,
    ImageBackground,
    ScrollView,
    SafeAreaView
} from 'react-native';
import RootStore from '../../Store';
import Colors from '../../Theme/Colors';
import typo from '../../Theme/Typo';
import Button from '../Button';
import Input from '../Input/Input';

const { userInfo } = RootStore.getInstance()

const BG_PATH = require("../../../assets/newDesign/background-portrait.png");

const Setting = () => {
    const { t, i18n } = useTranslation()
    const [email, setEmail] = useState<String>("")
    const [password, setPassword] = useState<String>("")
    const [isError, setError] = useState<Boolean>(false)


    return (
        <SafeAreaView style={typo.mainBackground}>
            <ImageBackground source={BG_PATH} style={typo.background}>
                <ScrollView>
                    <View style={typo.container}>
                        <Text style={typo.titleInfo}>{t("INFO_SETTING")}</Text>
                        
                        {/* <View style={typo.resCard}>
                            <Text style={[typo.category, { marginBottom: 10 }]}>{t("CHOICE_LANG")}</Text>
                        </View> */}
                        <View style={typo.resCard}>

                            <Text style={[typo.category]}>{t("CHANGE_RESERVATION")}</Text>

                            <View style={style.buttonWrapper}>
                                <Button
                                    style={{ alignSelf: "center", backgroundColor: Colors.oiqia }}
                                    text={t("LOGOUT")}
                                    onPress={() => userInfo.logout()}
                                />
                            </View>
                        </View>
                    </View>
                </ScrollView>
            </ImageBackground>
        </SafeAreaView>
    )
}

const style = StyleSheet.create({
    center: {
        flex: 1,
        justifyContent: "flex-end",
    },
    titleWelcome: {
        fontSize: 18,
        color: "black",
        textAlign: "center",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "RobotoMedium"
    },
    container: {
        flex: 1,
        backgroundColor: "#fff",
    },
    buttonWrapper: {
        width: "90%",
        alignSelf: "center",
        marginTop: 40,
    },
})

export default observer(Setting);